import * as S from "effect/Schema";
export const ArbmedvvCharacter = S.Literal("mandatory", "offered", "internal", "fitness", "elective", "not_specified");
export const arbmedvvCharacterLabels = {
    mandatory: { "de-DE": "Pflichtvorsorge", "en-US": "Pflichtvorsorge" },
    offered: { "de-DE": "Angebotsvorsorge", "en-US": "Angebotsvorsorge" },
    internal: {
        "de-DE": "Interne Untersuchung",
        "en-US": "Interne Untersuchung",
    },
    fitness: { "de-DE": "Eignungsuntersuchung", "en-US": "Eignungsuntersuchung" },
    elective: { "de-DE": "Wunschvorsorge", "en-US": "Wunschvorsorge" },
    not_specified: { "de-DE": "Ohne Angabe", "en-US": "Ohne Angabe" },
};
export const decodeArbmedvvCharacter = (value) => {
    switch (value.trim()) {
        case "1":
            return "mandatory";
        case "2":
            return "offered";
        case "3":
            return "internal";
        case "4":
            return "fitness";
        case "5":
            return "elective";
        default:
            return "not_specified";
    }
};
/** Import summaries keep the report's one-based data-row indices. */
export const ExaminationReportImportResult = S.Struct({
    matched_count: S.Int,
    not_found_count: S.Int,
    not_found: S.Array(S.Struct({
        row_index: S.Int,
        first_name: S.String,
        last_name: S.String,
        examination_abbreviation: S.String,
        reason: S.String,
    })),
    entries_created: S.Int,
    skipped_duplicates: S.Int,
});
export const ExaminationReportImportFailureCode = S.Literal("unreadable_file", "missing_columns", "internal_error");
//# sourceMappingURL=precautionary-index.js.map